import React from 'react';
import InterviewMediaUpload from '../pages/InterviewMediaUpload';
const statusColors = {
  null: {
    name: 'No Application',
    color: '#ADB5BD',
  },
  applicationStarted: {
    name: 'Application Started',
    color: '#ADB5BD',
  },
  applicationSubmitted: {
    name: 'Application Submitted',
    color: '#A0DCE1',
  },
  activated: {
    name: 'Activated',
    color: '#C3E6CB',
  },
  review: {
    name: 'In Review',
    color: '#FFEB99',
  },
  interview: {
    name: 'Interview',
    color: '#FFE5CC',
  },
  interviewReview: {
    name: 'Interview Review',
    color: '#FFDD99',
  },
  onboarding: {
    name: 'Onboarding',
    color: '#CCE5FF',
  },
  locationRejected: {
    name: 'Location Rejected',
    color: '#F8D7DA',
  },
  applicationRejected: {
    name: 'Application Rejected',
    color: '#F8D7DA',
  },
  expired: {
    name: 'Expired',
    color: '#A2A4A7',
  },
};
export default function StatusTag({ status }) {
  return (
    <div
      className="inline-flex items-center px-10 py-2 rounded-full text-md font-medium"
      style={{
        backgroundColor: statusColors[status]?.color,
      }}>
      {statusColors[status]?.name}
    </div>
  );
}
